export default __webpack_public_path__ + "static/eldbjorg-3afc8f794523826840a32d0b35ed6864.jpeg";